<template>
  <v-card :loading="loading">
    <v-toolbar flat>
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
      <v-spacer />
      <small>
        {{ people.length }}
      </small>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="people"
        :items-per-page="-1"
        hide-default-footer
        sort-by="sortOrder"
        dense
      >
        <template #[`item.cellPhone`]="{ item }">
          {{ item.cellPhone ? item.cellPhone : item.phone | phoneNumber }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'OrganizationRoleCategoryComponent',
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      loadingPeople: true,
      category: null,
      people: [],
      headers: [
        { text: 'Navn', value: 'fullName', width: '25%' },
        { text: 'Titel', value: 'title', width: '20%' },
        { text: 'Rolle', value: 'roleTitle', width: '25%' },
        { text: 'Telefon', value: 'cellPhone', width: 200 },
        { text: 'E-mail', value: 'email', width: '20%' }
      ]
    }
  },
  mounted() {
    this.getCategory();
    this.getPeople();
  },
  methods: {
    getCategory: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get(`role-categories/${this.id}`);

        this.category = data;
      } catch (error) {
        this.$notifier.showError({});
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getPeople: async function() {
      this.loadingPeople = true;

      try {
        const { data } = await this.$api.get('users', {
          params: {
            roleCategoryId: this.id
          }
        });

        this.people = data;
      } catch (error) {
        this.$notifier.showError({});
        console.log(error);
      } finally {
        this.loadingPeople = false;
      }
    }
  }
}
</script>
